import React, {Component} from 'react';
import Moment from 'react-moment';
import EuroFormat from '../../../components/EuroFormat/EuroFormat';
import Loading from '../../../components/Loading';
import WHTable from '../../../components/WHTable';
import ApiConfig from '../../../constants/ApiConfig';
import {CSVLink, CSVDownload} from 'react-csv';
import {ToastContainer, toast} from 'react-toastify';


import {
    Card,
    CardHeader,
    CardBody,
    Table,
    Badge,
    DropdownItem,
    Button
} from 'reactstrap';

import {connect} from 'react-redux';

import * as postService from '../../../services/post';
import parameters from "../../../constants/parameters";

class Posts extends Component {

    constructor(props) {

        super(props);

        this.state = {
            data: [],
            col: [],
            pages: null,
            loaded: true,
            defaultFilter: [{id: 'postType', value: 10}]

        }
        this.load = this.load.bind(this);
        this.columns = this.columns.bind(this);
        this.showdetails = this.showdetails.bind(this);

    }

    columns() {

        return [

            {
                Header: '',
                accessor: 'id',
                filterable: false,
                Cell: row => (<Button color={'success'}
                                      onClick={() => this.showdetails(row.value)}>Details</Button>),
                maxWidth: 80
            },
            {
                Header: 'titre',
                accessor: 'title'

            },
            {
                Header: 'site web',
                accessor: 'webSite',
                Filter: ({ filter, onChange }) => (
                    <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: '100%' }}
                        value={filter ? filter.value : 'all'}>
                        <option value="">Tout</option>
                        <option value="1">Oui</option>
                        <option value="0">Non</option>
                    </select>
                ),
                Cell: row => (
                    <div className="text-center">
                        {row.value && <Badge color="success">Oui</Badge>}
                        {!row.value && <Badge color="danger">Non</Badge>}
                    </div>

                ),

            },
            {
                Header: 'seller',
                accessor: 'seller',
                Filter: ({ filter, onChange }) => (
                    <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: '100%' }}
                        value={filter ? filter.value : 'all'}>
                        <option value="">Tout</option>
                        <option value="1">Oui</option>
                        <option value="0">Non</option>
                    </select>
                ),
                Cell: row => (
                    <div className="text-center">
                        {row.value && <Badge color="success">Oui</Badge>}
                        {!row.value && <Badge color="danger">Non</Badge>}
                    </div>
                ),

            },
            {
                Header: 'customer',
                accessor: 'buyer',
                Filter: ({ filter, onChange }) => (
                    <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: '100%' }}
                        value={filter ? filter.value : 'all'}>
                        <option value="">Tout</option>
                        <option value="1">Oui</option>
                        <option value="0">Non</option>
                    </select>
                ),
                Cell: row => (
                    <div className="text-center">
                        {row.value && <Badge color="success">Oui</Badge>}
                        {!row.value && <Badge color="danger">Non</Badge>}
                    </div>

                ),

            },
            {
                Header: 'Resumé',
                accessor: 'summary'
            },
            {
                Header: 'Source',
                accessor: 'terreNetId',

                Cell: row => (
                    <div className="text-center">
                        {row.value === null && <Badge color="info">Vaesken</Badge>}
                        {row.value != null && <Badge color="info">TerreNet</Badge>}
                    </div>

                ),
            },
            {
                Header: 'Template',
                accessor: 'postListTemplate',
                Cell: row => (
                    <div className="text-center">
                        {row.value === 'template1' && <div color="info">Texte et image</div>}
                        {row.value === 'template2' && <div color="info">Texte</div>}
                        {row.value === 'template3' && <div color="info">Carousel</div>}
                        {row.value === 'template4' && <div color="info">Évènement</div>}
                    </div>

                ),
            },
            {
                Header: 'Type',
                accessor: 'postType',
                Filter: ({ filter, onChange }) => (
                    <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: '100%' }}
                        value={filter ? filter.value : '10'}>
                        <option value="">Tout</option>
                        <option value="0">Quoi de neuf ?</option>
                        <option value="10">Actu Vaesken</option>
                        <option value="100">Les dates à retenir</option>
                    </select>
                ),
                Cell: row => (
                    <div className="text-center">
                        {row.value === 0 && <div color="info">Quoi de neuf ?</div>}
                        {row.value === 10 && <div color="info">Actu Vaesken</div>}
                        {row.value === 100 && <div color="info">Les dates à retenir</div>}
                    </div>

                ),
            },


            {
                Header: 'Publié',
                accessor: 'published',
                Filter: ({ filter, onChange }) => (
                    <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: '100%' }}
                        value={filter ? filter.value : 'all'}>
                        <option value="">Tout</option>
                        <option value="1">publié</option>
                        <option value="0">brouillon</option>
                    </select>
                ),
                Cell: row => (
                    <div className="text-center">
                        {row.value && <Badge color="success">publié</Badge>}
                        {!row.value && <Badge color="danger">brouillon</Badge>}
                    </div>
                ),
            },
            {
                Header: 'Date de publication',
                accessor: 'publicationDate',
                Cell: row => (<Moment format="DD/MM/YYYY">{row.value}</Moment>),
                maxWidth: 150,
                filterable: false
            },
          {
            Header: 'En avant Home',
            accessor: 'topHomeDate',
            Cell: row => row.value ? (<Moment format="DD/MM/YYYY">{row.value}</Moment>) : '',
            filterable: false
          },
            {
                Header: '',
                accessor: 'id',
                filterable: false,
                maxWidth: 110,
                Cell: row => (
                  <Button color={'danger'} onClick={() => this.remove(row.value)}>
                    <i className={'fa fa-trash'} />
                  </Button>)

            },
        ];

    }

    showdetails(id) {

        this.props.history.push(`/posts/edit/${id}`);

    }

    remove(toDelete) {

        if (confirm('Etes vous sûre de vouloir supprimer cet item ?')) {

            this.setState({loaded: false});

            postService.remove(toDelete).then((data) => {

                let lst = this.state.data;

                let index = lst.findIndex((el) => el.id == toDelete);

                if (index > -1) {

                    lst.splice(index, 1);

                    this.setState({data: lst, loaded: true});

                }

                toast.success('Post supprimé');

            }).catch((error) => {

                alert('Il existe des dépendances sur post, il ne peut donc être supprimé');

            });
        }

    }


    load(state, instance) {

        this.setState({loaded: false});

        return postService.search(state).then((data) => {

            this.setState({data: []}, () => {
                this.setState({
                    data: data['hydra:member'],
                    pages: Math.ceil(data['hydra:totalItems'] / state.pageSize),
                    loaded: true
                })
            });

        });

    }

    render() {

        const {history, match} = this.props;
        const {data, pages, loading} = this.state;

        return (
            <div className="animated fadeIn">


                <Card>
                    <CardHeader>
                        <i className="fa fa-align-justify"></i> Gestion des articles

                        <div className="card-actions">
                            <a href={`#/posts/edit`}><i className={'fa fa-plus'}></i> Créer</a>
                             {/*<a href={`${ApiConfig.helpAdmin}/cms/post.html`}
                               target={'_blank'}><i className={'fa fa-question'}></i></a>*/}
                        </div>

                    </CardHeader>

                    <WHTable
                        data={data}
                        pages={pages}
                        columns={this.columns()}
                        filterable={true}
                        onFetchData={this.load}
                        defaultFiltered={this.state.defaultFilter}
                        loading={!this.state.loaded}
                    />

                </Card>


            </div>
        )
    }
}

export default Posts





// WEBPACK FOOTER //
// ./src/views/Cms/Posts/Posts.js